import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const articles = [
  {
    to: "/artykul/przewodnik-usfansspreadsheet",
    img: "https://readdy.ai/api/search-image?query=Clean%20modern%20desk%20workspace%20with%20laptop%20showing%20spreadsheet%20interface%20alongside%20a%20notepad%20and%20pen%2C%20warm%20cream%20wall%20background%2C%20soft%20natural%20window%20light%2C%20minimalist%20productive%20setup%2C%20editorial%20photography%20with%20calm%20and%20focused%20atmosphere&width=600&height=400&seq=art1-v2-a9m3&orientation=landscape",
    bgClass: "bg-accent-100",
    titleKey: "articles.guide_title",
    excerptKey: "articles.guide_excerpt",
  },
  {
    to: "/artykul/bezpieczenstwo-usfansspreadsheet",
    img: "https://readdy.ai/api/search-image?query=Abstract%20representation%20of%20data%20security%20with%20a%20glowing%20shield%20symbol%20over%20a%20clean%20minimalist%20desk%20setup%2C%20soft%20cream%20background%2C%20warm%20subtle%20lighting%2C%20modern%20concept%20photography%2C%20professional%20and%20trustworthy%20aesthetic&width=600&height=400&seq=art2-v2-b5n8&orientation=landscape",
    bgClass: "bg-secondary-100",
    titleKey: "articles.safety_title",
    excerptKey: "articles.safety_excerpt",
  },
  {
    to: "/artykul/porownanie-usfansspreadsheet",
    img: "https://readdy.ai/api/search-image?query=Split%20screen%20comparison%20visualization%20showing%20two%20minimalist%20laptop%20setups%20side%20by%20side%20on%20a%20warm%20cream%20surface%2C%20soft%20natural%20lighting%2C%20clean%20modern%20aesthetic%2C%20editorial%20product%20comparison%20photography%2C%20balanced%20and%20harmonious%20composition&width=600&height=400&seq=art3-v2-c7w2&orientation=landscape",
    bgClass: "bg-background-200",
    titleKey: "articles.comparison_title",
    excerptKey: "articles.comparison_excerpt",
  },
  {
    to: "/artykul/jak-korzystac-usfansspreadsheet",
    img: "https://readdy.ai/api/search-image?query=Step%20by%20step%20tutorial%20setup%20on%20a%20clean%20cream%20desk%20with%20open%20notebook%20showing%20handwritten%20steps%20beside%20a%20laptop%20displaying%20spreadsheet%20data%2C%20warm%20natural%20lighting%20from%20window%2C%20organized%20and%20inspiring%20workspace%2C%20editorial%20photography%20with%20soft%20shadows&width=1200&height=500&seq=art4-v2-d3x1&orientation=landscape",
    bgClass: "md:col-span-2 lg:col-span-2",
    titleKey: "articles.tutorial_title",
    excerptKey: "articles.tutorial_excerpt",
    wide: true,
  },
  {
    to: "/artykul/opinia-usfansspreadsheet",
    img: "",
    bgClass: "bg-secondary-100",
    titleKey: "articles.review_title",
    excerptKey: "articles.review_excerpt",
    noImg: true,
  },
  {
    to: "/artykul/jak-uzywac-usfansspreadsheet",
    img: "https://readdy.ai/api/search-image?query=Hands%20typing%20on%20a%20laptop%20keyboard%20with%20spreadsheet%20data%20visible%20on%20screen%2C%20warm%20cream%20desk%20setup%20with%20a%20coffee%20cup%20nearby%2C%20soft%20morning%20light%2C%20authentic%20working%20moment%2C%20editorial%20lifestyle%20photography%20with%20natural%20warm%20tones&width=600&height=400&seq=art6-v2-f1p4&orientation=landscape",
    bgClass: "bg-accent-100",
    titleKey: "articles.howto_title",
    excerptKey: "articles.howto_excerpt",
  },
  {
    to: "/artykul/alternatywy-usfansspreadsheet",
    img: "https://readdy.ai/api/search-image?query=Five%20different%20minimalist%20product%20cards%20arranged%20in%20a%20row%20on%20a%20warm%20cream%20surface%20representing%20choices%20and%20alternatives%2C%20soft%20diffused%20lighting%2C%20clean%20modern%20presentation%2C%20editorial%20comparison%20concept%20photography%20with%20balanced%20composition&width=600&height=400&seq=art7-v2-g8q7&orientation=landscape",
    bgClass: "bg-background-200",
    titleKey: "articles.alternatives_title",
    excerptKey: "articles.alternatives_excerpt",
  },
  {
    to: "/artykul/dla-poczatkujacych",
    img: "https://readdy.ai/api/search-image?query=Beginner%20friendly%20workspace%20with%20a%20clean%20laptop%20screen%20showing%20simple%20spreadsheet%20tutorial%20steps%2C%20a%20welcoming%20cup%20of%20tea%20and%20a%20small%20plant%20on%20a%20warm%20cream%20desk%2C%20soft%20natural%20light%20creating%20a%20calm%20learning%20atmosphere%2C%20approachable%20and%20comforting%20photography%20style&width=600&height=400&seq=art8-v2-h2s5&orientation=landscape",
    bgClass: "bg-secondary-100",
    titleKey: "articles.beginners_title",
    excerptKey: "articles.beginners_excerpt",
  },
  {
    to: "/artykul/funkcje-usfansspreadsheet",
    img: "https://readdy.ai/api/search-image?query=Feature%20rich%20spreadsheet%20interface%20displayed%20on%20a%20modern%20laptop%20screen%20with%20colorful%20charts%20and%20data%20visualizations%2C%20clean%20cream%20desk%20setup%20with%20organized%20accessories%2C%20soft%20natural%20lighting%2C%20professional%20productivity%20photography%20with%20sophisticated%20aesthetic&width=600&height=400&seq=art9-v2-j6t9&orientation=landscape",
    bgClass: "bg-accent-100",
    titleKey: "articles.features_title",
    excerptKey: "articles.features_excerpt",
  },
  {
    to: "/artykul/prywatnosc-usfansspreadsheet",
    img: "https://readdy.ai/api/search-image?query=Privacy%20concept%20with%20a%20modern%20laptop%20screen%20showing%20a%20lock%20icon%20over%20spreadsheet%20data%2C%20clean%20cream%20desk%20with%20subtle%20shadows%2C%20soft%20diffused%20lighting%2C%20trustworthy%20and%20secure%20atmosphere%2C%20professional%20editorial%20photography%20with%20warm%20and%20safe%20feeling&width=600&height=400&seq=art10-v2-k3r1&orientation=landscape",
    bgClass: "bg-background-200",
    titleKey: "articles.privacy_title",
    excerptKey: "articles.privacy_excerpt",
  },
  {
    to: "/artykul/mobilny-usfansspreadsheet",
    img: "https://readdy.ai/api/search-image?query=Smartphone%20and%20tablet%20displaying%20spreadsheet%20app%20interface%20on%20a%20warm%20cream%20surface%2C%20modern%20mobile%20workspace%20concept%2C%20soft%20natural%20lighting%20from%20above%2C%20clean%20minimal%20composition%2C%20contemporary%20tech%20lifestyle%20photography%20with%20warm%20tones&width=600&height=400&seq=art11-v2-m5e7&orientation=landscape",
    bgClass: "bg-secondary-100",
    titleKey: "articles.mobile_title",
    excerptKey: "articles.mobile_excerpt",
  },
  {
    to: "/artykul/wskazowki-usfansspreadsheet",
    img: "https://readdy.ai/api/search-image?query=Notebook%20with%20numbered%20tips%20and%20tricks%20beside%20a%20laptop%20showing%20spreadsheet%20data%2C%20warm%20cream%20desk%20surface%2C%20soft%20natural%20window%20light%2C%20organized%20study%20setup%2C%20editorial%20lifestyle%20photography%20with%20productive%20and%20inspiring%20atmosphere&width=600&height=400&seq=art12-v2-n9u4&orientation=landscape",
    bgClass: "bg-accent-100",
    titleKey: "articles.tips_title",
    excerptKey: "articles.tips_excerpt",
  },
  {
    to: "/artykul/integracja-usfansspreadsheet",
    img: "https://readdy.ai/api/search-image?query=Multiple%20app%20icons%20floating%20around%20a%20central%20laptop%20screen%20on%20a%20warm%20cream%20background%2C%20abstract%20integration%20concept%2C%20soft%20modern%20aesthetic%2C%20clean%20tech%20visualization%2C%20editorial%20photography%20style%20with%20harmonious%20composition%20and%20subtle%20shadows&width=600&height=400&seq=art13-v2-p2w8&orientation=landscape",
    bgClass: "bg-background-200",
    titleKey: "articles.integration_title",
    excerptKey: "articles.integration_excerpt",
  },
  {
    to: "/artykul/spolecznosc-usfansspreadsheet",
    img: "https://readdy.ai/api/search-image?query=Community%20forum%20concept%20with%20multiple%20small%20avatar%20bubbles%20around%20a%20central%20laptop%20screen%20on%20a%20warm%20cream%20surface%2C%20soft%20diffused%20lighting%2C%20friendly%20and%20welcoming%20atmosphere%2C%20modern%20social%20tech%20photography%20with%20clean%20composition%20and%20gentle%20warm%20tones&width=600&height=400&seq=art14-v2-q4z0&orientation=landscape",
    bgClass: "bg-secondary-100",
    titleKey: "articles.community_title",
    excerptKey: "articles.community_excerpt",
  },
];

export default function ArticlesSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="text-center mb-12">
          <span className="inline-flex items-center gap-2 text-accent-600 text-sm font-semibold tracking-wide uppercase mb-3">
            <div className="w-2 h-2 rounded-full bg-accent-500"></div>
            {t("articles.label")}
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 max-w-2xl mx-auto">
            {t("articles.title")}
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {articles.map((article, i) => {
            if (article.wide) {
              return (
                <Link
                  key={i}
                  to={article.to}
                  className={`group rounded-lg overflow-hidden ${article.bgClass} cursor-pointer`}
                >
                  <div className="relative h-64 md:h-72 rounded-lg overflow-hidden">
                    <img
                      src={article.img}
                      alt={t(article.titleKey)}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      loading="lazy"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-primary-500/80 via-primary-500/20 to-transparent"></div>
                    <div className="absolute bottom-0 left-0 right-0 p-6">
                      <h3 className="font-heading text-xl font-semibold text-background-50 mb-1">
                        {t(article.titleKey)}
                      </h3>
                      <p className="text-background-100/80 text-sm">
                        {t(article.excerptKey)}
                      </p>
                    </div>
                  </div>
                </Link>
              );
            }

            return (
              <Link
                key={i}
                to={article.to}
                className={`group rounded-lg overflow-hidden transition-all cursor-pointer ${article.bgClass}`}
              >
                <div className="p-5 md:p-6 h-full flex flex-col">
                  {!article.noImg && article.img && (
                    <div className="w-full h-40 rounded-md overflow-hidden mb-4">
                      <img
                        src={article.img}
                        alt={t(article.titleKey)}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                        loading="lazy"
                      />
                    </div>
                  )}
                  <div className="w-8 h-8 flex items-center justify-center mb-3 text-accent-400">
                    <i className="ri-double-quotes-l text-2xl"></i>
                  </div>
                  <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-2 group-hover:text-accent-600 transition-colors">
                    {t(article.titleKey)}
                  </h3>
                  <p className="text-foreground-600 text-sm leading-relaxed flex-grow">
                    {t(article.excerptKey)}
                  </p>
                  <span className="inline-flex items-center gap-1.5 text-accent-600 text-sm font-medium mt-4 group-hover:gap-2.5 transition-all whitespace-nowrap">
                    {t("articles.read_more")}
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-arrow-right-line text-xs"></i>
                    </div>
                  </span>
                </div>
              </Link>
            );
          })}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/artykul/przewodnik-usfansspreadsheet"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 text-sm font-medium rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            Zobacz wszystkie artykuły
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-xs"></i>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}